import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import { useParams } from 'react-router-dom';
import { IShareEmailErrorState, IShareEmailMainState } from '../ShareEmailDialog';
import {
    MailSendOptionEnum,
    onConfirmShareEmail,
} from '../../../../../redux/project/documents/sliceProjectShareEmail';

const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
    color: vars.white,
};

export default ({ setShowErrorState, mainState, onClose }: IShareEmailDialogActionsProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'shareEmailDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();
    const params = useParams();

    const { replicaId } = params;

    const isLoading = useSelector(
        (_store: IAppReduxStore) => _store.projectDocumentsShareEmail.loading,
    );

    const { data: documents } = useSelector(
        (_store: IAppReduxStore) => _store.projectDocuments.info,
    );

    const validateInput = () => {
        setShowErrorState({
            subject: mainState.subject === '',
            sendTo: mainState.sendTo.length === 0,
            replyTo: mainState.replyTo.length === 0,
            mailSendOption:
                mainState.mailSendOption !== MailSendOptionEnum.DownloadLink &&
                mainState.mailSendOption !== MailSendOptionEnum.FileAttachment,
            documentTypeName: mainState.documentTypeName === '',
        });
        return (
            mainState.subject !== '' &&
            mainState.sendTo.length !== 0 &&
            mainState.replyTo.length !== 0 &&
            (mainState.mailSendOption === MailSendOptionEnum.DownloadLink ||
                mainState.mailSendOption === MailSendOptionEnum.FileAttachment) &&
            mainState.documentTypeName !== ''
        );
    };
    const onSendEmail = () => {
        if (validateInput()) {
            dispatch(
                onConfirmShareEmail({
                    ...mainState,
                    replicaId,
                }),
            );
        }
    };
    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            <Button
                variant={'text'}
                onClick={onClose}
                sx={{ ...buttonSx, color: vars.font }}
                disabled={isLoading}
            >
                {t('ctaCancel')}
            </Button>
            <Button
                variant={'contained'}
                onClick={onSendEmail}
                sx={buttonSx}
                disabled={!documents?.length || isLoading}
            >
                {t('ctaSend')}
            </Button>
        </DialogActions>
    );
};

interface IShareEmailDialogActionsProps {
    setShowErrorState: Dispatch<React.SetStateAction<IShareEmailErrorState>>;
    mainState: IShareEmailMainState;
    onClose: () => void;
}
